@if (!loadChild) {
    <mat-spinner class="mx-auto mt-5 mb-5"></mat-spinner>
} @else if (loadChild) {
    <app-planning-detail [dialogRef]="dialogRef" [planning]="planning"></app-planning-detail>
}
